import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { DOCUMENT_AGENT_QUERY_KEYS } from '../config'
import type { AgentRunDetailResponse } from '../model'

export function useAgentRun(documentKey: string, runId: string | undefined) {
  return useQuery({
    queryKey: DOCUMENT_AGENT_QUERY_KEYS.run(documentKey, runId ?? ''),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/document-agent/documents/{key}/runs/{run_id}',
        path: { key: documentKey, run_id: runId },
        throwOnError: true,
      })
      return response.data as AgentRunDetailResponse
    },
    enabled: Boolean(runId),
    retry: retryUnlessClientError,
  })
}
